import React from "react";
import SalesUploadsContainer from "../../modules/GASalesPages/containers/SalesUploadsContainer/SalesUploadsContainer";

const GASalesUploads = () => {
  return <SalesUploadsContainer />;
};

export default GASalesUploads;
